import React from "react";
import PropTypes from "prop-types";
import { FaEdit, FaEye } from "react-icons/fa";
import { Popup as LeafletPopup } from "react-leaflet";

import InstitutionDetailsInner from "./InstitutionDetailsInner";

const Popup = props => {
  const {
    institution: i,
    may_edit,
    onEditInstitution,
    onCloseManually,
    onOpenDetailView,
    onSearchTag,
    isActive
  } = props;

  return (
    <LeafletPopup autoClose={false} closeButton={false}>
      <div className="leaflet-content">
        <InstitutionDetailsInner
          institution={i}
          showAll={false}
          onSearchTag={onSearchTag}
        />
        {isActive && (
          <div className="buttons has-text-left is-full-width">
            {may_edit && (
              <button
                onClick={() => onEditInstitution(i._key)}
                className="button is-info is-medium"
                title="Bearbeiten"
              >
                <FaEdit className="is-small" />
              </button>
            )}
            <button
              className="button is-medium is-primary"
              onClick={onOpenDetailView}
              title="Details"
            >
              <FaEye />
            </button>
            <button
              className="button is-medium is-primary"
              onClick={onCloseManually}
              title="Schließen"
            >
              <span>Schließen</span>
            </button>
          </div>
        )}
      </div>
    </LeafletPopup>
  );
};

Popup.propTypes = {
  institution: PropTypes.object,
  may_edit: PropTypes.bool,
  isActive: PropTypes.bool,
  onEditInstitution: PropTypes.func,
  onCloseManually: PropTypes.func,
  onOpenDetailView: PropTypes.func
};

Popup.defaultProps = {
  onCloseManually: f => f
};

export default Popup;



/** WEBPACK FOOTER **
 ** ./src/components/Popup.jsx
 **/